
























































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";

import RentalBookingJson from "../../shared/RentalBookingJson";
import CustomerJson from "../../shared/CustomerJson";
import { RentalBookingStatus, RentalBookingStatusNames } from "../../shared/RentalBookingStatus";

import SettingsJson from "../../shared/SettingsJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import RentalBookingDetails from "./RentalBookingDetails.vue";
import RentalBookingDetailsAdd from "./RentalBookingDetailsAdd.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "RentalBookings",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    RentalBookingDetails,
    RentalBookingDetailsAdd,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      RentalBookingStatus: RentalBookingStatus,
      RentalBookingStatusNames: RentalBookingStatusNames,
      GeneralInfos: GeneralInfos,
      supportsDatePicker: false,
      showDetails: false,
      showDetailsAdd: false as boolean,
      detailsMode: "read",
      bookings: null as RentalBookingJson[] | null,
      useFilters: false as boolean,
      filterStates: null as RentalBookingStatus | null,
      cachedFilterDates: {
        afterDate: "",
        beforeDate: "",
      } as { [index: string]: string },
      filterDates: {
        afterDate: "",
        beforeDate: "",
      } as { [index: string]: string },
      searchString: null as string | null,
      bookingsMoreAvailable: false as boolean | null,
      selectedBookingId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: RentalBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedBookingId = item.ID;
      } else {
        this.selectedBookingId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadBookings();
    },

    async loadBookings(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchString !== null) {
        if (loadMore == null) {
          this.bookings = null;
        }
        if (this.searchString == "") {
          this.searchString = null;
        }
      }

      let states = null;
      let rentalItemId = null;
      let afterDate = null;
      let beforeDate = null;
      let skipAmount = null as number | null;

      //filters
      if (this.useFilters) {
        if (this.filterStates != null) {
          states = [this.filterStates];
        }

        if (this.filterDates["afterDate"] != "") {
          afterDate = new Date(this.filterDates["afterDate"]);
        }

        if (this.filterDates["beforeDate"] != "") {
          beforeDate = new Date(this.filterDates["beforeDate"]);
        }
      }

      //load more
      if (loadMore && this.bookings != null) {
        this.bookingsMoreAvailable = null;
        skipAmount = this.bookings.length;
      } else {
        this.bookings = null;
      }

      //final load bookings
      if (this.restClient != null) {
        try {
          let rentals = await this.restClient.getRentalBookings(
            states,
            rentalItemId,
            afterDate,
            beforeDate,
            this.searchString,
            skipAmount
          );

          if (loadMore && this.bookings != null) {
            this.bookings = this.bookings.concat(rentals.rentalBookings);
          } else {
            this.bookings = rentals.rentalBookings;
          }

          this.bookingsMoreAvailable = rentals.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadBookings();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadBookings();
    },

    removeUseFilters() {
      this.useFilters = false;
      this.filterStates = null;
      this.cachedFilterDates["afterDate"] = "";
      this.cachedFilterDates["beforeDate"] = "";
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadBookings();
    },

    resetSearchString() {
      this.searchString = "";
      this.loadBookings();
    },

    //START date handling

    setFilterDates() {
      var filterDate = "";

      let k = this.cachedFilterDates;
      let i: keyof typeof k;

      for (i in this.cachedFilterDates) {
        if (this.supportsDatePicker) {
          filterDate = this.cachedFilterDates[i];
        } else {
          if (this.cachedFilterDates[i].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedFilterDates[i]);

            if (d != null) {
              filterDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.filterDates[i] = filterDate;
      }
    },

    //END date handling

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    tableViewBookingColumns: function (): TableViewColumnDefinitions<RentalBookingJson>[] {
      if (
        this.filterStates == "paymentExported" ||
        this.filterStates == "paymentReceived" ||
        this.filterStates == "cancellationFeeExported" ||
        this.filterStates == "cancellationFeeReceived"
      ) {
        return this.bookingPaymentColumns;
      } else {
        return this.bookingColumns;
      }
    },

    bookingColumns: function (): TableViewColumnDefinitions<RentalBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Organisation",
          td: (i) =>
            i.customer?.guardianOrganisation != null && i.customer?.guardianOrganisation != ""
              ? i.customer?.guardianOrganisation
              : "--",
        },
        {
          th: "Vorname",
          td: (i) =>
            i.customer?.guardianFirstName != null && i.customer?.guardianFirstName != ""
              ? i.customer?.guardianFirstName
              : "--",
        },
        {
          th: "Nachname",
          td: (i) =>
            i.customer?.guardianLastName != null && i.customer?.guardianLastName != ""
              ? i.customer?.guardianLastName
              : "--",
        },
        {
          th: "Produkt",
          td: (i) => i.rentalItem?.name,
        },
        {
          th: "Zeitraum",
          td: (i) =>
            vue.DateFormatter.formatDateWeekday(new Date(i.beginDate)) +
            " – " +
            vue.DateFormatter.formatDateWeekday(new Date(i.endDate)),
        },
        {
          th: "Status",
          td: (i) => vue.RentalBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<RentalBookingJson>[];
    },

    bookingPaymentColumns: function (): TableViewColumnDefinitions<RentalBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Organisation",
          td: (i) =>
            i.customer?.guardianOrganisation != null && i.customer?.guardianOrganisation != ""
              ? i.customer?.guardianOrganisation
              : "--",
        },
        {
          th: "Vorname",
          td: (i) =>
            i.customer?.guardianFirstName != null && i.customer?.guardianFirstName != ""
              ? i.customer?.guardianFirstName
              : "--",
        },
        {
          th: "Nachname",
          td: (i) =>
            i.customer?.guardianLastName != null && i.customer?.guardianLastName != ""
              ? i.customer?.guardianLastName
              : "--",
        },
        {
          th: "Produkt",
          td: (i) => i.rentalItem?.name,
        },
        {
          th: "Zeitraum",
          td: (i) =>
            vue.DateFormatter.formatDateWeekday(new Date(i.beginDate)) +
            " – " +
            vue.DateFormatter.formatDateWeekday(new Date(i.endDate)),
        },
        {
          th: "Status",
          td: (i) => vue.RentalBookingStatusNames[i.state],
        },
        {
          th: "Rechnungsnummer",
          td: (i) =>
            i.invoiceInfos != null && i.invoiceInfos.length > 0
              ? i.invoiceInfos[i.invoiceInfos.length - 1].invoiceNumber
              : "--",
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<RentalBookingJson>[];
    },
  },
});
